import React, { useState, useEffect } from 'react';
import { Box, Grid, Stack, Typography, CircularProgress } from '@mui/material';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import { useSelector } from 'react-redux';
import RewardCard from './RewardCard';
import RewardOfferCard from './RewardOfferCard';
// import { fetchData } from '../../../Utils/UtilsFunctions';
import { environment } from '../../../../environments/environment';
import { auth } from '../../../../../../../libs/firebase-service/src';

const Rewards = () => {
  const userData = useSelector((state) => state.authReducer.userData);
  const [loyaltyData, setLoyaltyData] = useState(null);
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Reward tiers from loyalty program (if available)
  const rewardTiers = loyaltyData?.message?.program?.rewardTiers || [];

  useEffect(() => {
    const fetchLoyaltyData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Check if user has phone number
        if (!userData?.phoneNumber) {
          setError('Phone number not available');
          setLoading(false);
          return;
        }

        // Get authentication token
        const token = await auth?.currentUser?.getIdToken();
        const headers = {
          'Content-Type': 'application/json',
          Authorization: token,
        };

        // Remove leading '+' from phone number if present
        const sanitizedPhoneNumber = String(userData.phoneNumber || '').replace(
          /^\+/,
          ''
        );

        // Note: parameters are sent as query string, no body is used
const loyaltyProgramId =
          environment.restaurantId === 'fattyPattyDev' 
            ? '832fe29b-3700-4977-ad33-be88f6aa9a54'
            : 'a66ddd7b-362d-4fea-ab5b-dd06974aaf21';
        const query = new URLSearchParams({
          phoneNumber: sanitizedPhoneNumber,
          restaurantId: environment.restaurantId,
          programId: loyaltyProgramId,
        }).toString();

        const responseRaw = await fetch(
          `${environment.apiUrl}/loyalty/accounts?${query}`,
          {
            method: 'GET',
            headers,
          }
        );

        const response = await responseRaw.json();

        if (response) {
          setLoyaltyData(response);
        }
      } catch (err) {
        console.error('Error fetching loyalty data:', err);
        setError('Failed to load loyalty data');
      } finally {
        setLoading(false);
      }
    };

    if (userData) {
      

      fetchLoyaltyData();
    }
  }, [userData]);
  

  // Prepare cards data from API response or use defaults
  const cards = [
    {
      title: 'Total Earned',
      value: loyaltyData?.message?.account?.lifetimePoints || 0,
      subtitle: 'Lifetime earnings',
    },
    {
      title: 'Balance ',
      value: loyaltyData?.message?.account?.balance || 0,
      subtitle: 'Points available for redemption',
    },
    {
      title: 'Total Redeemed',
      value: loyaltyData?.message?.account?.totalRedeemedPoints || 0,
      subtitle: 'Used for rewards',
    },
  ];

  if (loading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress sx={{ color: environment.mainColor }} />
        <Typography sx={{ mt: 2, color: '#4A5565' }}>
          Loading your rewards...
        </Typography>
      </Stack>
    );
  }

  if (error) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <Typography sx={{ color: '#ef4444', fontWeight: 600, mb: 1 }}>
          {error}
        </Typography>
        <Typography sx={{ color: '#4A5565' }}>
          Please try again later
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack alignItems={'center'} gap={4}>
      <Grid container spacing={2}>
        {cards.map((c) => (
          <Grid item key={c.title} xs={12} sm={6} md={4}>
            <RewardCard title={c.title} value={c.value} subtitle={c.subtitle} />
          </Grid>
        ))}
      </Grid>
      <Stack sx={{ textAlign: 'center', alignItems: 'center', gap: 1 }}>
        <Typography
          variant="h4"
          component="h2"
          sx={{
            fontWeight: 700,
            color: '#383838',
            fontFamily: 'Jost , sans-serif',
            fontSize: { xs: '24px', sm: '30px', lg: '36px' },
          }}
        >
          Available Rewards
        </Typography>

        <Typography
          sx={{
            color: '#4A5565',
            maxWidth: '650px',
            mx: 'auto',
            fontSize: { xs: '14px', sm: '16px', lg: '18px' },
            lineHeight: { xs: '20px', sm: '24px', lg: '28px' },
          }}
        >
          Redeem your points for exclusive deals, free items, and special perks.
          The more you dine with us, the better the rewards get!
        </Typography>

        {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              border: '1px solid rgba(255,106,0,0.15)',
              borderRadius: 2,
              px: 2.5,
              py: 1,
              background: '#fff',
            }}
          >
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 28,
                height: 28,
                borderRadius: '50%',
                background: 'rgba(255,106,0,0.08)',
                color: '#ff6a00',
                mr: 1.25,
              }}
            >
              <CardGiftcardIcon sx={{ fontSize: 18 }} />
            </Box>

            <Typography sx={{ fontWeight: 700 }}>
              You have {loyaltyData?.message?.account?.balance} points to spend
            </Typography>
          </Box>
        </Box> */}
      </Stack>
      {/* Offers section (new) */}
      <Box sx={{ width: '100%', px: 0.5, maxWidth: 900 }}>
        <Typography sx={{ fontWeight: 700, fontSize: 20, mb: 2 }}>
          Available Offers
        </Typography>

        <Grid container spacing={3}>
          {rewardTiers && rewardTiers.length > 0 ? (
            rewardTiers.map((tier) => (
              <Grid item key={tier.id} xs={12} sm={6} md={6}>
                <RewardOfferCard
                  title={tier.name}
                  points={tier.points}
                  description={
                    tier.pricingRule?.pricingRuleData?.name ||
                    tier.discount?.discountData?.name
                  }
                  appliedLocations={loyaltyData?.message?.program?.locationIds}
                  productDetails={tier.productDetails}
                  productType={tier.productType}
                  productSet={tier.productSet}
                />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Typography sx={{ color: '#4A5565' }}>
                No offers available
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </Stack>
  );
};

export default Rewards;
